export enum BidStatus {
    start = "start", // not part of BankId spec, but we use it to start the login
    pending = "pending",
    failed = "failed",
    complete = "complete"
}

export enum BidHintCode {
    certificateErr = "certificateErr",
    expiredTransaction = "expiredTransaction",
    noClient = "noClient",
    outstandingTransaction = "outstandingTransaction",
    started = "started",
    startFailed = "startFailed",
    userCancel = "userCancel",
    userSign = "userSign"
}

export type BidAuth = {
    autoStartToken: string;
    orderRef: string;
    qrCode: string;
};

export type BankIdData = {
    autoStartToken: string;
    qrStartToken: string;
    orderRef: string;
    status?: BidStatus;
    hintCode?: BidHintCode;
    qrCode?: string;
};

export type BidCollect = {
    status: BidStatus;
    hintCode: BidHintCode;
    qrCode: string;
    access_token?: string;
    token_type?: string;
    expires_in?: string;
    user_display_name?: string;
    user_id?: string;
    accepted_terms?: boolean;
};
